enum RecommendationTab {
  Recommendations = 'Рекомендации',
  Diet = 'Питание',
  Supplements = 'БАД и\xA0др.'
}

export default RecommendationTab
